import React, { useRef, useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import MaterialTable from 'material-table';
import { useReactToPrint } from 'react-to-print';


// reactstrap components
import { Button, Card, CardBody, CardHeader, FormGroup, Form, Input, Row, Col } from "reactstrap";

// style
import { table_translate } from "../../../constants/MaterialTable.js";

// helpers
import { formateDateApi, formateDateandTime, formateDate } from '../../../helpers/formats';
import { showMessage } from "../../../helpers/message.js";

// api
import guiadestinacao_api from '../../../api/guiadestinacao_api';

//Context
import { useAuth } from "../../../context/auth.js";

export default function RelEntradaIndividual({ handleReturn }) {
    const { session, setLoading, logoTipo } = useAuth();
    console.log(session)
    const { register, handleSubmit, errors } = useForm({ mode: "onBlur" });

    const [relatorio, set_relatorio] = useState(null)

    const Voltar = () => {
        handleReturn();
    }

    useEffect(() => {
    }, []);

    const [filtro, set_filtro] = useState(null);

    const onSubmit = (data) => {
        let json_submit = {
            localId: session.localId,
            dataInicial: formateDateApi(data.dataInicial),
            dataFinal: formateDateApi(data.dataFinal)
        }
        setLoading(true);
        guiadestinacao_api.relatorio(json_submit).then(result => {
            setLoading(false);
            if (result.status !== 200) {
                showMessage("Aviso", result.message, 'error', null);
            }
            else {
                set_filtro(json_submit);
                set_relatorio(result.data);
            }
        });
    }

    //Referencia para o componente de impressão
    const ref = useRef(null);
    //Estilo da pagina de impressão
    const pageStyle = `
    @page { 
        size: auto;  margin: 3mm ;
    } 
    @media print { 
        body { -webkit-print-color-adjust: exact; } 
    }
    @media print {
        @page{
        size:A4;
        margin:0;
        }
        .relatorios {
        width: 100vw!important;
        display:flex;
        flex-direction:column;
        }
    }
    `;

    //Função assionada assim que o botão de imprimir é clicado
    const handlePrint = useReactToPrint({
        content: () => ref.current,
        copyStyles: true,
        documentTitle: "Relatório de Guias de Destinação",
        pageStyle: pageStyle
    });

    return (
        <>
            <div className="content pageSizePrint" ref={ref}>
                <Row>
                    <Col md="6" className="noPrint">
                        <Button color="Primary" onClick={Voltar}><i className="fas fa-chevron-left"></i>  Voltar</Button>
                    </Col>
                    <Col md="6" className="text-right noPrint">
                        {relatorio != null &&
                            <Button color="danger" onClick={handlePrint}><i className="fas fa-print"></i></Button>
                        }
                    </Col>
                    <Col md="12">
                        <Card>
                            <CardHeader>
                                <div>
                                    {filtro != null &&
                                        <div className='d-flex justify-content-center align-items-center py-2'>
                                            <img src={logoTipo} alt="Logo prefeitura" />
                                        </div>
                                    }
                                    <div className='col-md-9'>
                                        <h4 className="mb-0 mt-0">Relatório de Guias de Destinação</h4>
                                        <label className="rel-subtitle">Relatório detalhado de guias de destinação.</label>
                                    </div>
                                    <div className="col-md-3 text-start">
                                        {relatorio != null &&
                                            <label className="rel-subtitle">Gerado em {formateDateandTime(new Date())}</label>
                                        }
                                    </div>
                                </div>
                            </CardHeader>
                            <CardBody>
                                <Form onSubmit={handleSubmit(onSubmit)}>
                                    {relatorio == null &&
                                        <Row className="noPrint">
                                            <Col lg="3" md="3" sm="6">
                                                <FormGroup>
                                                    <label className="form-control-label">Data Inicial:</label>
                                                    <Input className="form-control"
                                                        autocomplete="off"
                                                        type="date"
                                                        name="dataInicial"
                                                        innerRef={register({ required: true })}
                                                    />
                                                    {errors.dataInicial && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                                                </FormGroup>
                                            </Col>
                                            <Col lg="3" md="3" sm="6">
                                                <FormGroup>
                                                    <label className="form-control-label">Data Final:</label>
                                                    <Input className="form-control"
                                                        autocomplete="off"
                                                        type="date"
                                                        name="dataFinal"
                                                        innerRef={register({ required: true })}
                                                    />
                                                    {errors.dataFinal && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                                                </FormGroup>
                                            </Col>
                                            <Col lg="3" md="3" sm="12">
                                                <Button color="info" className="btn-mobile mt-4" type="submit"> Gerar Relatório</Button>
                                            </Col>
                                        </Row>
                                    }
                                    {filtro != null &&
                                        <>
                                            <Row className="rel-filter">
                                                <Col md="5">
                                                    <span><b>Período</b></span><br /><span>{formateDate(filtro.dataInicial) + " a " + formateDate(filtro.dataFinal)}</span>
                                                </Col>
                                                <Col md="4">
                                                    <span><b>Gerado Por</b></span><br /><span>{session.nome}</span>
                                                </Col>
                                                <Col md="3">
                                                    <span><b>Local</b></span><br /><span>{session.nome}</span>
                                                </Col>
                                            </Row>
                                        </>
                                    }
                                    <div className="relatorio" >
                                        {relatorio != null && relatorio?.guiaDestinacaoRelatorio.map((m, key) => (
                                            <>
                                                <Row className="rel-title-item" key={key}>
                                                    <Col md="12" className="pb-2">
                                                        <h5>Número: {" " + m.numeroGuia}</h5>
                                                    </Col>
                                                    <Col md="6" className="pb-2">
                                                        <span><b>Data: </b></span><span>{" " + formateDate(m.dataHora)}</span>
                                                    </Col>
                                                    <Col md="6" className="pb-2">
                                                        <span><b>Usuário: </b></span><span>{" " + m.usuario}</span>
                                                    </Col>
                                                    <Col md="6" className="pb-2">
                                                        <span><b>Documento Transportador: </b></span><span>{" " + m.documento}</span>
                                                    </Col>
                                                    <Col md="6" className="pb-2">
                                                        <span><b>Transportador: </b></span><span>{" " + m.identificacaoTransportador}</span>
                                                    </Col>
                                                    <Col md="6" className="pb-2">
                                                        <span><b>Destino: </b></span><span>{" " + m.identificacaoDestino}</span>
                                                    </Col>
                                                    <Col md="6" className="pb-2">
                                                        <span><b>Endereço Destino: </b></span><span>{" " + m.logradouro + ", " + m.numero + ", " + m.bairro + " ," + m.cidade + ", " + m.uf + " - " + m.cep}</span>
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col md="12" className="relatorio-table">
                                                        <MaterialTable
                                                            title=""
                                                            columns={[
                                                                { title: 'Resíduos', field: 'tipoResiduoDescricao' },
                                                                { title: 'Quantidade', field: 'quantidade', render: rowData => rowData.quantidade + " " + rowData.tipoResiduoUnidade },
                                                            ]}
                                                            data={m.guiaDestinacaoTipoResiduoRelatorio}
                                                            isLoading={false}
                                                            options={{
                                                                headerStyle: {
                                                                    fontFamily: 'Montserrat, Helvetica Neue, Arial, sans-serif',
                                                                    fontWeight: '700',
                                                                    color: '#888',
                                                                },
                                                                cellStyle: {
                                                                    padding: "5px",
                                                                    paddingLeft: "15px"
                                                                },
                                                                search: false,
                                                                filtering: false,
                                                                exportButton: false,
                                                                paging: false,
                                                                rowStyle: x => {
                                                                    if (x.tableData.id % 2) {
                                                                        return { backgroundColor: "#f2f2f2" }
                                                                    }
                                                                }
                                                            }}
                                                            localization={table_translate}
                                                        />
                                                    </Col>
                                                </Row>
                                            </>
                                        ))}
                                        {relatorio != null && relatorio?.totalizadorTipoResiduoRelatorio?.length > 0 &&
                                            <Row className="rel-title-item">
                                                <Col lg="12" className="py-2">
                                                    <span><b>Totalizadores de Resíduos: </b></span><span>{formateDate(filtro.dataInicial) + " a " + formateDate(filtro.dataFinal)}</span>
                                                </Col>
                                                <Col md="12" className="relatorio-table">
                                                    <MaterialTable
                                                        title=""
                                                        columns={[
                                                            { title: 'Resíduos', field: 'tipoResiduoDescricao' },
                                                            { title: 'Quantidade', field: 'quantidade', render: rowData => rowData.quantidade + " " + rowData.tipoResiduoUnidade },
                                                        ]}
                                                        data={relatorio.totalizadorTipoResiduoRelatorio}
                                                        isLoading={false}
                                                        options={{
                                                            headerStyle: {
                                                                fontFamily: 'Montserrat, Helvetica Neue, Arial, sans-serif',
                                                                fontWeight: '700',
                                                                color: '#888',
                                                            },
                                                            cellStyle: {
                                                                padding: "5px",
                                                                paddingLeft: "15px"
                                                            },
                                                            search: false,
                                                            filtering: false,
                                                            exportButton: false,
                                                            paging: false,
                                                            rowStyle: x => {
                                                                if (x.tableData.id % 2) {
                                                                    return { backgroundColor: "#f2f2f2" }
                                                                }
                                                            }
                                                        }}
                                                        localization={table_translate}
                                                    />
                                                </Col>
                                            </Row>

                                        }
                                    </div>
                                </Form>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>

            </div>

        </>
    );
}

